module.exports = __webpack_public_path__ + "media/proksee-viewer/images/cb-move-counter-clockwise-711514f9703e6df90b5a24bd23705e54.png";